/*
<summary>
   This functional component is all about rendering the Add/Edit Tool BOM popup visibility wrapper.
   Developer: Aashish Singh, Created Date: 07-Sep-2026
</summary>
<param>No Parameter Passed</param>
<returns>Returns JSX</returns>
*/

import React, { useState } from 'react';

/**
* This function is used to wrap a component with add/edit popup show/hide state and toggle handler.
* @param Component: Component to wrap with the popup visibility state
*/
const AddToolBOMPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showAddToolBOMPopup, setShowAddToolBOMPopup] =
      useState<boolean>(false);

    const addToggleHandler = () => {
      setShowAddToolBOMPopup(!showAddToolBOMPopup);
    };

    return (
      <Component
        showAddToolBOMPopup={showAddToolBOMPopup}
        addToggleHandler={addToggleHandler}
        {...props}
      />
    );
  };

export default AddToolBOMPopupHOC;
